export default {
	CONTEXT: 'context',
	LEAGUE:  'league',
};
